import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuccessData } from 'types/api';

export const notificationsMutations = getMutations({
  markNotificationAsRead: {
    action: async ({ timestamp }: { timestamp: string }): Promise<SuccessData> => {
      return executeApiCall({
        path: `/users/notifications`,

        payload: {
          timestamp,
        },
      });
    },

    messages: {
      suppressError: true,
      suppressSuccess: true,
    },
  },
});
